<template>
  <div class="modal__content modal__content--max p20 pt30">
    <h3 class="text-medium text-uppercase text-size-16 text-left text-height-12 mb15 text-center-xs-down">project notes:</h3>
    <textarea type="text" class="mb20 form-control form-control--no-resize form-control--placeholder-gray form-control--notes" 
      v-model="clientCharacterNotes" :placeholder="clientCharacterNotes"></textarea>
    <button class="btn btn--block text-uppercase" @click="editNotes()">Save</button>
  </div>
</template>

<script>
import { errorMessage } from '@/modules/Error'
import { mapActions } from 'vuex'
import { apiProjectUpdateClientCharacterNotes } from '@/api/project.api'

export default {
  data () {
    return {
      clientCharacterNotes: ""
    }
  },

  props: ['args'],

  methods: {
    ...mapActions([
      'updateProjectProperties'
    ]),

    init () {
      this.clientCharacterNotes = this.args.project.clientCharacterNotes ? this.args.project.clientCharacterNotes : ""
    },

    async editNotes () {
      const note = {
        projectId: this.args.project.id,
        clientCharacterNotes: this.clientCharacterNotes
      }

      this.$bus.$emit('loaderShow')

      const [err, data] = await apiProjectUpdateClientCharacterNotes(note)
      this.$bus.$emit('loaderClose')
      if (err) return errorMessage(err, 'Unable to edit client character notes in this project. Try again later!')

      this.updateProjectProperties({clientCharacterNotes: data.clientCharacterNotes})
      return this.$bus.$emit('toastSuccess', 'Notes sucessfully updated!')
    }
  },

  created () {
    this.init()
  }
}
</script>


// WEBPACK FOOTER //
// ClientCharacterNotes.vue?128da7b4